interface IRecommendationContentLookup {
	[attributeName: string]: {
		heading: string;
		status: (...args: any) => string;
		action: (attributePoints: number) => string;
		buttonText: string;
		buttonLink: (propertyId?: number) => string;
	};
}

export const contentLookup: IRecommendationContentLookup = {
	// min stay
	pricing_minimum_stay_average: {
		heading: 'Minimum nights stay',
		status: (attributePoints: number) => {
			switch (attributePoints) {
				case 1: return 'Your minimum nights stay is 6 or 7 nights.';
				case 2: return 'Your minimum nights stay is 4 or 5 nights.';
				case 3: return 'Your minimum nights stay is 3 nights.';
				case 4: return 'Your minimum nights stay is 2 nights.';
				case 5: return 'Your minimum nights stay is 1 night.';
				default: return '';
			}
		},
		action: (attributePoints: number) => {
			switch (attributePoints) {
				case 1: return 'Lower your minimum nights stay to 1 or 2 nights to attract more short-stay bookings.';
				case 2: return 'Lower your minimum nights stay to 1 or 2 nights to attract more short-stay bookings.';
				case 3: return 'Lower your minimum nights stay to 1 or 2 nights to attract more short-stay bookings.';
				case 4: return 'Lower your minimum nights stay to 1 night to attract more short-stay bookings.';
				default: return '';
			}
		}, buttonText: 'Update min. nights stay',
		buttonLink: (propertyId: number) => `/property/${propertyId}/details/pricing`
	},
	// pricing
	pricing_expiry: {
		heading: 'Upcoming pricing periods',
		status: (attributePoints: number) => {
			switch (attributePoints) {
				case 1: return 'You only have between 0 and 2 months of pricing within the next two years.';
				case 2: return 'You only have between 2 and 3 months of pricing within the next two years.';
				case 3: return 'You only have between 3 and 6 months of pricing within the next two years.';
				case 4: return 'You only have between 6 and 12 months of pricing within the next two years.';
				case 5: return 'Your upcoming pricing is set up for 12 months or more.';
				default: return '';
			}
		},
		action: (attributePoints: number) => {
			switch (attributePoints) {
				case 1: return 'Add pricing for your property up to two years to attract more bookings.';
				case 2: return 'Add pricing for your property up to two years to attract more bookings.';
				case 3: return 'Add pricing for your property up to two years to attract more bookings.';
				case 4: return 'Add pricing for your property up to two years to attract more bookings.';
				default: return '';
			}
		}, buttonText: 'Update pricing',
		buttonLink: (propertyId: number) => `/property/${propertyId}/details/pricing`
	},
	// smart cancellation preference
	cancellation_preference_auto_adjustment: {
		heading: 'Cancellation preference',
		status: (attributePoints: number) => {
			switch (attributePoints) {
				case 1: return 'You do not have Smart cancellation policy enabled.';
				case 5: return 'You have Smart cancellation policy enabled.';
				default: return 'You do not have Smart cancellation policy enabled.';
			}
		},
		action: () => 'The Property Experts recommend this policy to maximise bookings.',
		buttonText: 'Update cancellation preference',
		buttonLink: (propertyId: number) => `/property/${propertyId}/details/cancellation-policy`
	},
	// channel selection
	distribution_contracts_bookingcom_selected: {
		heading: 'Channel selection',
		status: (attributePoints: number) => {
			switch (attributePoints) {
				case 5: return 'You have selected Booking.com.';
				default: return 'You have not selected Booking.com.';
			}
		},
		action: () => 'Properties listed on Booking.com see 3-4X more bookings.',
		buttonText: 'Update channels',
		buttonLink: () => '/redirect/channels'
	},
	distribution_contracts_airbnb_selected: {
		heading: 'Channel selection',
		status: (attributePoints: number) => {
			switch (attributePoints) {
				case 5: return 'You have selected Airbnb.';
				default: return 'You have not selected Airbnb.';
			}
		},
		action: () => 'Properties listed on Airbnb see 2-3X more bookings.',
		buttonText: 'Update channels',
		buttonLink: () => '/redirect/channels'
	},
	distribution_contracts_tripadvisor_selected: {
		heading: 'Channel selection',
		status: (attributePoints: number) => {
			switch (attributePoints) {
				case 5: return 'You have selected TripAdvisor.';
				default: return 'You have not selected TripAdvisor.';
			}
		},
		action: () => 'Properties listed on TripAdvisor attract more bookings.',
		buttonText: 'Update channels',
		buttonLink: () => '/redirect/channels'
	},
	distribution_contracts_homeaway_selected: {
		heading: 'Channel selection',
		status: (attributePoints: number) => {
			switch (attributePoints) {
				case 5: return 'You have selected VRBO.';
				default: return 'You have not selected VRBO.';
			}
		},
		action: () => 'Properties listed on Vrbo attract more bookings.',
		buttonText: 'Update channels',
		buttonLink: () => '/redirect/channels'
	},
	distribution_contracts_expedia_selected: {
		heading: 'Channel selection',
		status: (attributePoints: number) => {
			switch (attributePoints) {
				case 5: return 'You have selected Expedia.';
				default: return 'You have not selected Expedia.';
			}
		},
		action: () => 'Properties listed on Expedia attract more bookings.',
		buttonText: 'Update channels',
		buttonLink: () => '/redirect/channels'
	},
	distribution_contracts_holidu_selected: {
		heading: 'Channel selection',
		status: (attributePoints: number) => {
			switch (attributePoints) {
				case 5: return 'You have selected Holidu.';
				default: return 'You have not selected Holidu.';
			}
		},
		action: () => 'Properties listed on Holidu attract more bookings.',
		buttonText: 'Update channels',
		buttonLink: () => '/redirect/channels'
	},
	// photos
	image_count: {
		heading: 'Number of photos',
		status: (attributePoints: number) => {
			switch (attributePoints) {
				case 1: return 'You have less than 10 photos.';
				case 2: return 'You have between 10 and 20 photos.';
				case 3: return 'You have between 20 and 25 photos.';
				case 4: return 'You have between 26 and 30 photos.';
				case 5: return 'You have more than 30 photos.';
				default: return '';
			}
		},
		action: () => 'Increase the number of photos to 31. Include photos of each room, plus the outside of the property. The first photo should be an appealing, landscape (horizontal) image.',
		buttonText: 'Update photos',
		buttonLink: (propertyId: number) => `/property/${propertyId}/details/photos`
	},
	image_horizontal_orientation_percentage: {
		heading: 'Photo orientation',
		status: (attributePoints: number) => {
			switch (attributePoints) {
				case 1: return 'Three quarters of your photos are in portrait (vertical) orientation.';
				case 2: return 'More than half of your photos are in portrait (vertical) orientation.';
				case 3: return 'More than half of your photos are in landscape (horizontal) orientation.';
				case 4: return 'More than three quarters of your photos are in landscape (horizontal) orientation.';
				case 5: return 'All your photos are in landscape orientation.';
				default: return '';
			}
		},
		action: () => 'Replace any photos in portrait orientation with new photos taken in landscape orientation.',
		buttonText: 'Update photos',
		buttonLink: (propertyId: number) => `/property/${propertyId}/details/photos`
	},
	image_y_dimension_average: {
		heading: 'Photo quality - Y Dimension',
		status: (attributePoints: number) => {
			switch (attributePoints) {
				case 1: return 'The quality of most of your photos is very poor.';
				case 2: return 'The quality of most of your photos is poor.';
				case 3: return 'The quality of most of your photos is average.';
				case 4: return 'The quality of most of your photos is good.';
				case 5: return 'The quality of most of your photos is very good.';
				default: return '';
			}
		},
		action: () => 'Update all low resolution photos with new photos taken at a resolution of 2000+ pixels.',
		buttonText: 'Update photos',
		buttonLink: (propertyId: number) => `/property/${propertyId}/details/photos`
	},
	image_x_dimension_average: {
		heading: 'Photo quality - X Dimension',
		status: (attributePoints: number) => {
			switch (attributePoints) {
				case 1: return 'The quality of most of your photos is very poor.';
				case 2: return 'The quality of most of your photos is poor.';
				case 3: return 'The quality of most of your photos is average.';
				case 4: return 'The quality of most of your photos is good.';
				case 5: return 'The quality of most of your photos is very good.';
				default: return '';
			}
		},
		action: () => 'Update all low resolution photos with new photos taken at a resolution of 2000+ pixels.',
		buttonText: 'Update photos',
		buttonLink: (propertyId: number) => `/property/${propertyId}/details/photos`
	},
	// marketing preferences
	marketing_preferences_promotion_selected: {
		heading: 'Promotions',
		status: (attributePoints: number) => {
			switch (attributePoints) {
				case 5: return 'You have selected at least one promotion.';
				default: return 'You have not enabled a promotion.';
			}
		},
		action: () => 'Promotions are a great way to attract more guests and boost the visibility of your property.',
		buttonText: 'Enable promotions',
		buttonLink: (propertyId: number) => `/property/${propertyId}/details/promotions`
	},
	// property
	property_amenity_wifi_present: {
		heading: 'Wifi',
		status: (attributePoints: number) => {
			switch (attributePoints) {
				case 5: return 'Your property has WiFi.';
				default: return 'Your property does not have WiFi.';
			}
		},
		action: () => 'WiFi is consistently rated as the most important vacation rental amenity. Installing WiFi will make your property much more appealing to guests.',
		buttonText: 'Update WiFi',
		buttonLink: (propertyId: number) => `/property/${propertyId}/details/amenities`
	},
	property_restriction_children_allowed: {
		heading: 'House rules - children',
		status: (attributePoints: number) => {
			switch (attributePoints) {
				case 5: return 'Children are allowed in your property.';
				default: return 'Your property does not allow children.';
			}
		},
		action: () => 'Allowing children could help you attract 2-3X more bookings.',
		buttonText: 'Update house rules',
		buttonLink: (propertyId: number) => `/property/${propertyId}/details/rules`
	},
	property_restriction_infants_allowed: {
		heading: 'House rules - infants',
		status: (attributePoints: number) => {
			switch (attributePoints) {
				case 5: return 'Infants are allowed in your property.';
				default: return 'Your property does not allow infants.';
			}
		},
		action: () => 'Allowing infants could help you attract 2-3X more bookings.',
		buttonText: 'Update house rules',
		buttonLink: (propertyId: number) => `/property/${propertyId}/details/rules`
	},
	property_restriction_pets_allowed: {
		heading: 'House rules - pets',
		status: (attributePoints: number) => {
			switch (attributePoints) {
				case 5: return 'Your property is pet-friendly.';
				default: return 'Your property does not allow pets.';
			}
		},
		action: () => 'Making your property pet-friendly could help you attract 2X more bookings and appeal to a far wider audience.',
		buttonText: 'Update house rules',
		buttonLink: (propertyId: number) => `/property/${propertyId}/details/rules`
	},
	property_restriction_cleaning_fee_amount: {
		heading: 'Cleaning fee',
		status: (attributePoints: number) => {
			switch (attributePoints) {
				case 1: return 'Your cleaning fee is £150 or more.';
				case 2: return 'Your cleaning fee is between £75 and £150.';
				case 3: return 'Your cleaning fee is between £25 and £75.';
				case 4: return 'Your cleaning fee is between £0 and £25.';
				case 5: return 'You have no cleaning fee.';
				default: return '';
			}
		},
		action: () => 'Remove your cleaning fee or incorporate it into your nightly rate to attract more bookings.',
		buttonText: 'Update cleaning fee',
		buttonLink: (propertyId: number) => `/property/${propertyId}/details/security-deposit-and-cleaning-fee`
	},
	property_security_deposit_amount: {
		heading: 'Security deposit',
		status: (attributePoints: number) => {
			switch (attributePoints) {
				case 1: return 'Your security deposit is £200 or more.';
				case 2: return 'Your security deposit is between £100 and £200.';
				case 3: return 'Your security deposit is beween £0 and £100.';
				case 4: return 'Your security deposit is £0.';
				case 5: return 'Your security deposit is £0.';
				default: return '';
			}
		},
		action: () => 'Remove or reduce your security deposit to attract up to 2X more bookings.',
		buttonText: 'Update security deposit',
		buttonLink: (propertyId: number) => `/property/${propertyId}/details/security-deposit-and-cleaning-fee`
	},
	property_name_length: {
		heading: 'Listing headline',
		status: (attributePoints: number) => {
			switch (attributePoints) {
				case 1: return 'Your listing headline has between 1 and 9 characters. This is too short.';
				case 2: return 'Your listing headline has between 10 and 19 characters. This is too short.';
				case 3: return 'Your listing headline has between 20 and 29 characters. This is too short.';
				case 4: return 'Your listing headline has between 30 and 39 characters. This is slightly too short.';
				case 5: return 'Your listing headline has between 40 and 50 characters.';
				default: return '';
			}
		},
		action: () => 'Increase your listing headline to around 50 characters in length.',
		buttonText: 'Update listing headline',
		buttonLink: (propertyId: number) => `/property/${propertyId}/details/description`
	},
	property_advance_bookings_value: {
		heading: 'Booking notice period',
		status: (attributePoints: number) => {
			switch (attributePoints) {
				case 1: return 'Your booking notice period is 5 or more days.';
				case 2: return 'Your booking notice period is 4 days.';
				case 3: return 'Your booking notice period is 3 days.';
				case 4: return 'Your booking notice period is 2 days.';
				case 5: return 'Your booking notice period is 1 day.';
				default: return '';
			}
		},
		action: (attributePoints: number) => {
			if (attributePoints === 4) return 'Lower your booking notice period to 1 day to make your property even more appealing to guests looking for a last-minute break.';
			return 'Lower your booking notice period to 1 or 2 days to attract more last-minute bookings.';
		},
		buttonText: 'Update booking notice',
		buttonLink: (propertyId: number) => `/property/${propertyId}/details/check-in`
	},
};
